<ng-container [ngSwitch]="channel.type">
  <ng-template [ngSwitchCase]="'organization'">
    <sn-icon size="sm" fontSet="fa" fontIcon="fa-hashtag" *ngIf="isPublic"></sn-icon>
    <sn-icon size="sm" class="private-icon" *ngIf="!isPublic">lock</sn-icon>
  </ng-template>

  <sn-icon size="sm" class="private-icon" *ngSwitchCase="'team'">lock</sn-icon>

  <ng-template [ngSwitchCase]="'user'">
    <span class="group-icon" pill *ngIf="memberCount >= 2 && memberCount <= 10">
      {{ memberCount - 1 }}
    </span>
    <span class="group-icon" pill *ngIf="memberCount > 10"> 9+ </span>
  </ng-template>

  <ng-template [ngSwitchCase]="'team'">
    <span class="group-icon" pill *ngIf="memberCount >= 2 && memberCount <= 10">
      {{ memberCount - 1 }}
    </span>
    <span class="group-icon" pill *ngIf="memberCount > 10"> 9+ </span>
  </ng-template>
  <sn-user-status [sid]="userSid" *ngSwitchCase="'pair'"></sn-user-status>
</ng-container>
